<template>
  <div class="w-full h-full relative">
    <O3D v-if="renderer" class="">
      <MenuLayout></MenuLayout>
    </O3D>
    <MenuBar></MenuBar>
  </div>
</template>

<script>
import { RenderRoot } from '../Reusable/RenderRoot'
import { PCamera } from '../Reusable/PCamera'
// import { CubeCam } from '../Reusable/CubeCam'
import { Scene, Color } from 'three'
export default {
  mixins: [RenderRoot],
  components: {
  },
  data () {
    return {
      cubeCam: false,
      layouts: {
        flower: false
      },
      renderer: false,
      camera: false,
      scene: new Scene()
    }
  },
  methods: {
    setup () {
      this.camera = new PCamera({ element: this.renderRootElement, onResize: this.onResize })
      this.camera.position.z = 10
      this.camera.position.y = 0
      this.scene.add(this.o3d)
    }
  },
  mounted () {
    this.setup()

    // this.cubeCam = new CubeCam({
    //   res: 256,
    //   renderer: this.ctx.renderer,
    //   scene: this.ctx.scene,
    //   camera: this.ctx.camera,
    //   loop: this.onLoop,
    //   clean: this.onClean
    // })

    this.onLoop(() => {
      this.layouts.diamonds = {
        // ry: Math.PI
      }
    })

    this.scene.background = new Color('#232323')

    // this.renderRootElement.style.backgroundImage = `url('${require('./img/stained-glass.jpg')}')`
    // this.renderRootElement.style.backgroundImage = `url('${require('./img/skyspace.jpg')}')`
    // this.renderRootElement.style.backgroundSize = `cover`
    // this.renderRootElement.style.backgroundColor = `black`
    // this.renderRootElement.style.backgroundPosition = `center center`
    // this.renderRootElement.style.backgroundRepeat = `no-repeat no-repeat`
  },
  beforeDestroy () {
    document.body.style.cursor = ''
    // this.renderRootElement.style.backgroundSize = ``
    // this.renderRootElement.style.backgroundImage = ``
    // this.renderRootElement.style.backgroundColor = ``
    // this.renderRootElement.style.backgroundPosition = ``
    // this.renderRootElement.style.backgroundRepeat = ``
  }
}
</script>

<style>
</style>
